import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import type { SendOrganizationInquiryPayload } from '@/api/v4/organization.api';
import { sendOrganizationInquiry } from '@/api/v4/organization.api';
import { sendSpotlightOrganizationInquiry } from '@/api/v4/spotlight.api';
import { notify } from '@/ui/snackbar/notify';

export type SendOrganizationInquiryRequest = SendOrganizationInquiryPayload & {
  organizationId: string;
  useSpotlightInquiry?: boolean;
};

export const useSendInquiry = () => {
  const { t } = useTranslation('default');

  return useMutation({
    mutationFn: ({
      organizationId,
      useSpotlightInquiry,
      ...payload
    }: SendOrganizationInquiryRequest) =>
      useSpotlightInquiry
        ? sendSpotlightOrganizationInquiry(organizationId, payload)
        : sendOrganizationInquiry(organizationId, payload),
    onError: () => {
      notify({
        message: t('unknownError'),
      });
    },
  });
};
